import { makeStyles, css } from '@conexasaude/conexa-hero'

const useStyles = makeStyles({
  container: ({ spacing }) => css`
    margin-top: ${spacing.sm};
  `,

  boxContainer: ({ spacing }) => css`
    display: grid;
    margin: ${spacing.xs} 0;
    grid-template-columns: repeat(3, 1fr);
    gap: ${spacing.xxs};
  `,

  containerDetails: ({ spacing }) => css`
    margin: ${spacing.xs} 0;
  `,
})

export default useStyles
